/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Origin_Compliance_Llm_ImageInputs */



/**
* | output |
* | --- |
* | "Compliance LLM (Image)" |
*
* @param {Audit_Origin_Compliance_Llm_ImageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_origin_compliance_llm_image = /** @type {((inputs?: Audit_Origin_Compliance_Llm_ImageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Origin_Compliance_Llm_ImageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Compliance LLM (Bild)")
	return /** @type {LocalizedString} */ ("Compliance LLM (Image)")
});